<select class="languageSelector" [(ngModel)]="selectedLanguage" (change)="onLanguageChange($event)">
    <option *ngFor="let language of languages" [value]="language.lang">{{ language.name }}</option>
</select>